<script setup lang="ts">
import { useToggleStore } from '@/store/toggle/toggle'

import type { Product } from '@/types/api/api-v3/product'
import type { OneProductV5 } from '@/types/api/api-v5/product'
import { ProductParentType } from '@/types/components/product-card.types'
import { TagSize } from '@/types/products'

import ProductOldTag from '@/components/Product/ProductItem/ProductTags/ProductTag.vue'
import ProductTagRating from '@/components/Product/ProductTags/ProductTagRating.vue'

type Props = {
  product: Product | OneProductV5
  parentComponent: string
}

const props = defineProps<Props>()

const { menuByPointsEnabled } = useToggleStore()

const tags = computed(() => {
  if (menuByPointsEnabled) {
    const product = props.product as OneProductV5
    return product.main_tags
  }

  const product = props.product as Product
  return product.tags
})
</script>

<template>
  <div class="product__tags">
    <product-tag-rating
      v-if="product.rating"
      :rating="product.rating"
      :type="ProductParentType.detail"
    />

    <product-old-tag
      v-for="tag in tags"
      :key="tag.name"
      :tag="tag"
      :size="TagSize.NORMAL"
    />
  </div>
</template>

<style scoped lang="scss">
.product__tags {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5;
  display: grid;
  gap: 12px 0;
  padding: 25px 0 0 5px;

  @include media('<=tablet') {
    padding: 0;
  }
}
</style>
